// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const Line_Type = {
    Notes: 3538944,
    Reference: 3538945,
    Service: 3538946,
    Goods: 3538947,
    Descriptive: 3538948,
};
